<dx-validation-group>
    <div class="login-header">
        <!-- <div class="title">{{appInfo.title}}</div> -->
        <img src="../../../../assets/images/logo.svg" alt="Pekar">
        <div class="text-white">Plan proizvodnje</div>
    </div>
    <div class="dx-field">
        <dx-text-box [(value)]="login" placeholder="Korisničko ime" width="100%">
            <dx-validator>
                <dxi-validation-rule type="required" message="Obavezno polje!"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>
    <div class="dx-field">
        <dx-text-box mode="password" [(value)]="password" placeholder="Lozinka" width="100%"
            (keyup.enter)="prijava(login, password)">
            <dx-validator>
                <dxi-validation-rule type="required" message="Obavezno polje!"></dxi-validation-rule>
            </dx-validator>
        </dx-text-box>
    </div>
    <!-- <div class="dx-field">
        <dx-check-box [value]="false" text="Remember me"></dx-check-box>
    </div> -->
    <div class="dx-field">
        <dx-button type="default" text="Prijava" (onClick)="onLoginClick($event, login, password)"
            width="100%"></dx-button>
    </div>
    <div class="dx-field">
        <p class="error-message">{{message}}</p>
    </div>
    <div class="float-right">
        <div class="text-white">
            <i>v: 20260205</i>
        </div>
    </div>
    <!-- <div class="dx-field">
        <a routerLink="/recovery">Forgot password ?</a>
    </div>
    <div class="dx-field">
        <dx-button type="normal" text="Create an account" width="100%"></dx-button>
    </div> -->
</dx-validation-group>